import { Column, Image, Text } from "@amzn/meridian";
import React from "react";

type SampleImageCardProps = {
  src: string;
};
const SampleImageCard = ({ src }: SampleImageCardProps) => {
  return (
    <Column
      backgroundColor="#575F67"
      width={132}
      height={132}
      spacingInset={"400"}
      className="sample-image-card"
      alignmentVertical="center"
      alignmentHorizontal="center"
    >
      {src ? (
        <Image size="108px" viewportAspectRatio={1} src={src} />
      ) : (
        <Text color="inverted">Image</Text>
      )}
    </Column>
  );
};

export default SampleImageCard;
